import React from "react";
import InterventionIcon from "../common/InterventionIcon";
import css from "./QuestionDefinition.css";
import PropTypes from 'prop-types';


export default class QuestionDefinition extends React.Component {


    render() {
        return (
            <li key={this.props.name} className={css['container']}>
                <div className={css['question-header']}>
                    <InterventionIcon category={this.props.category}
                                      name={this.props.name}/>
                    {this.props.name}
                </div>

                <div dangerouslySetInnerHTML={{__html: this.props.description}}/>

                <div className={css['question-studentView']}>
                    {this.props.studentView && <div className={"forStudentVisibleTestOnly"}>This {this.props.category} is visible
                        to the student.
                    </div>}

                </div>
            </li>
        );
    }

}
QuestionDefinition.propTypes = {
    category: PropTypes.string,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    studentView: PropTypes.bool,
}
